import { RoleGuard } from './../shared/route-guards/role.guard';
import { CreateComponent } from './components/create/create.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LocalsLogComponent } from './locals-log/locals-log.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '/list',
        pathMatch: 'full'
    },
    {
        path: 'list',
        component: LocalsLogComponent,
    },
    {
        path: 'create',
        component: CreateComponent,
        canActivate: [RoleGuard],
        data: {
            allowedRoles: ['SuperAdmin']
        }
    },
    {
        path: 'edit/:id',
        component: CreateComponent,
        canActivate: [RoleGuard],
        data: {
            allowedRoles: ['SuperAdmin']
        }
    },


];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LocalsRoutingModule { }
